export const AVATAR_SIZE = {
    small: 45,
    large: 122,
};

export const AVATAR_RADIUS = 10;
